"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitScreenMode = void 0;
var SplitScreenMode;
(function (SplitScreenMode) {
    SplitScreenMode[SplitScreenMode["LEFT"] = 0] = "LEFT";
    SplitScreenMode[SplitScreenMode["SPLIT"] = 1] = "SPLIT";
    SplitScreenMode[SplitScreenMode["RIGHT"] = 2] = "RIGHT";
})(SplitScreenMode = exports.SplitScreenMode || (exports.SplitScreenMode = {}));
//# sourceMappingURL=split-screen-types.js.map